export default __webpack_public_path__ + "static/media/stake-more-bcube.c2ca9501.svg";